import {
  FaGavel as FaAuction,
  FaBuilding,
  FaGavel,
  FaLandmark,
  FaLock,
  FaMoneyCheckAlt,
  FaShieldAlt,
  FaUserTie,
  FaVrCardboard,
} from "react-icons/fa";

export const isFeatureItem = (item: string) =>
  item.includes("ريال") || item.includes("SAR") || item.includes("%");

export const isSectionTitle = (item: string) =>
  /^(أولاً|ثانياً|ثالثاً|رابعاً|خامساً|سادساً|سابعاً|ثامناً|تاسعاً|عاشراً|First|Second|Third|Fourth|Fifth|Sixth|Seventh|Eighth|Ninth|Tenth)/.test(
    item,
  ) || (item.endsWith(":") && item.length < 80);

export const sectionIcons = [
  <FaShieldAlt key="shield" />,
  <FaUserTie key="user" />,
  <FaBuilding key="building" />,
  <FaLandmark key="landmark" />,
  <FaAuction key="auction" />,
  <FaLock key="lock" />,
  <FaVrCardboard key="vr" />,
  <FaLock key="lock2" />,
  <FaMoneyCheckAlt key="money" />,
  <FaGavel key="gavel" />,
];

/* ─── Feature Item ─── */
export function FeatureItem({ text }: { text: string }) {
  return (
    <div className="group flex items-center gap-4 rounded-2xl border border-[color-mix(in_srgb,var(--color-main)_10%,transparent)] bg-[color-mix(in_srgb,var(--color-main)_4%,white)] p-4 transition-all duration-200 hover:border-[color-mix(in_srgb,var(--color-main)_28%,transparent)] hover:shadow-md">
      <div className="flex size-9 shrink-0 items-center justify-center rounded-xl bg-[color-mix(in_srgb,var(--color-main)_12%,white)] text-main transition-transform duration-200 group-hover:scale-110">
        <FaMoneyCheckAlt className="text-sm" />
      </div>
      <p className="font-semibold text-slate-800">{text}</p>
    </div>
  );
}

/* ─── Content Item ─── */
export function ContentItem({ item }: { item: string }) {
  if (isFeatureItem(item)) return <FeatureItem text={item} />;

  if (isSectionTitle(item)) {
    return (
      <div className="mb-2 mt-10 first:mt-0">
        <div className="flex items-center gap-3">
          <span className="block h-0.5 w-5 rounded-full bg-main" />
          <p className="text-base font-black text-slate-900">{item}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-3">
      <span className="mt-2.5 size-1.5 shrink-0 rounded-full bg-[color-mix(in_srgb,var(--color-main)_45%,transparent)]" />
      <p className="text-base leading-relaxed text-slate-600">{item}</p>
    </div>
  );
}

/* ─── Sections (Fees) ─── */
export function SectionsContent({
  sections,
}: {
  sections: { subtitle: string; items: string[] }[];
}) {
  return (
    <div className="space-y-8">
      {sections.map((sec, si) => (
        <div key={si}>
          <div className="mb-4 flex items-center gap-3">
            <span className="block h-0.5 w-5 rounded-full bg-main" />
            <h3 className="text-base font-black text-slate-900">
              {sec.subtitle}
            </h3>
          </div>
          <div className="space-y-3 ps-3">
            {sec.items.map((item, ii) =>
              isFeatureItem(item) ? (
                <FeatureItem key={ii} text={item} />
              ) : (
                <div key={ii} className="flex gap-3">
                  <span className="mt-2.5 size-1.5 shrink-0 rounded-full bg-[color-mix(in_srgb,var(--color-main)_45%,transparent)]" />
                  <p className="text-base leading-relaxed text-slate-600">
                    {item}
                  </p>
                </div>
              ),
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
